$(document).ready(function () {
    $(document).on("click", "#load-more", function () {
      let $btn = $(this);
      let nextPageUrl = $btn.attr("data-next-page");
  
      if (!nextPageUrl) return;
  
      $.get(nextPageUrl, function (data) {
        let $newProducts = $(data).find("#product-grid").html();
        let $newButton = $(data).find("#load-more");
  
        $("#product-grid").append($newProducts);
  
        if ($newButton.length) {
          $btn.attr("data-next-page", $newButton.attr("data-next-page"));
        } else {
          $btn.remove();
        }
  
        // // Update URL
        // let url = new URL(window.location.href);
        // let currentPage = url.searchParams.get("page") || 1;
        // url.searchParams.set("page", Number(currentPage) + 1);
        // window.history.pushState({}, "", url);
      }).fail(function () {
        console.error("Error loading more products.");
      });
    });
  });
  